import "./index.css";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getPlanDates, getCoverageAmount } from "./GuideCardData";
import { ReactComponent as FillDetailsIcon } from "../../assets/svg/FillDetailsIcon.svg";
import { ReactComponent as FindImei } from "../../assets/svg/FindImei.svg";
import { ReactComponent as UploadIcon } from "../../assets/svg/UploadIcon.svg";
import { ReactComponent as WarningIcon } from "../../assets/svg/WarningIcon.svg";

const GuideCard = ({ selectedData }) => {
  const { currentDate, formattedEndDate } = getPlanDates(
    selectedData?.plan_Validity,
  );

  return (
    <Container fluid className="form-guide-card">
      <Row className="align-items-center">
        {/* ****** Guide Card Container ****** */}
        <Col lg={8} md={12}>
          <div className="form-fill-label-Txt-container">
            <div class="form-fill-label-Txt">
              Read this before you start filling the form
            </div>
            {/* ****** Fill Details Guide ****** */}
            <Row className="align-items-center">
              <Col lg={4} md={12}>
                <div className="d-flex flex-lg-column flex-row align-items-center guide-fill-container">
                  {/* <div className="d-flex flex-md-column flex-row align-items-center guide-fill-container"> */}
                  <FillDetailsIcon
                    width="40px"
                    height="40px"
                    style={{ marginBottom: "7px" }}
                  />
                  <div>
                    <div className="guide-fill-heading-Txt">
                      Fill in the details
                    </div>
                    <div className="guide-fill-sub-heading-Txt">
                      Open the link on another device and fill in the required
                      fields.
                    </div>
                  </div>
                </div>
              </Col>

              {/* ****** Check the IMEI ****** */}
              <Col lg={4} md={12}>
                {/* <div className="d-flex flex-md-column flex-row align-items-center guide-fill-container"> */}
                <div className="d-flex flex-lg-column flex-row align-items-center guide-fill-container">
                  <FindImei
                    width="40px"
                    height="40px"
                    style={{ marginBottom: "7px" }}
                  />
                  <div>
                    <div className="guide-fill-heading-Txt">Check the IMEI</div>
                    <div className="guide-fill-sub-heading-Txt">
                      Dial *#06# to check the IMEI details of the mobile device
                      you wish to insure.
                    </div>
                  </div>
                </div>
              </Col>

              {/* ****** Upload IMEI details ****** */}
              <Col lg={4} md={12}>
                <div className="d-flex flex-lg-column flex-row align-items-center guide-fill-container">
                  <UploadIcon
                    width="40px"
                    height="40px"
                    style={{ marginBottom: "7px" }}
                  />
                  <div>
                    <div className="guide-fill-heading-Txt">
                      Upload IMEI details
                    </div>
                    <div className="guide-fill-sub-heading-Txt">
                      Upload a clear video of the device's screen showing the
                      IMEI details.
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* ****** Screenshots Error Warning ****** */}
            <Col
              lg={4}
              md={12}
              className="screenshot-not-accept-warning-container"
            >
              <div className="d-flex  flex-row align-items-center warning-card-container">
                <WarningIcon width="20px" height="20px" />
                <div>
                  <div className="screenshot-not-accept-label-txt">
                    Screenshots are not accepted.
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </Col>

        <Col lg={4} md={12}>
          <div className="d-none d-md-block mt-4">
            <div className="plan-details-card">
              <div className="plan-detail-heading-txt">Plan Details</div>
              {/* ****** Plan Name ****** */}
              <Row className="d-flex justify-content-center">
                <div className="plan-detail-container">
                  <Col
                    style={{ width: "100%" }}
                    className="plan-name-value-container d-flex justify-content-center align-items-center"
                  >
                    <p
                      style={{ width: "30%" }}
                      className="plan-detail-label-key-txt"
                    >
                      Plan Name
                    </p>
                    <p
                      style={{ width: "70%" }}
                      className="plan-detail-label-value-txt"
                    >
                      :{" "}
                      {selectedData?.plan_Description
                        ? selectedData?.plan_Description
                        : "Protect"}
                    </p>
                  </Col>
                </div>
              </Row>

              {/* ****** Duration ****** */}
              {selectedData?.plan_Validity && (
                <Row className="d-flex justify-content-center">
                  <div className="plan-detail-container">
                    <Col
                      style={{ width: "100%" }}
                      // className="plan-name-value-container text-center"
                      className="plan-name-value-container d-flex justify-content-center align-items-center"
                    >
                      <p
                        style={{ width: "30%" }}
                        className="plan-detail-label-key-txt"
                      >
                        Duration
                      </p>
                      <p
                        style={{ width: "70%" }}
                        className="plan-detail-label-value-txt"
                      >
                        :{" "}
                        {selectedData?.plan_Validity === "12"
                          ? "1 Year"
                          : `${selectedData?.plan_Validity} months`}
                      </p>
                    </Col>
                  </div>
                </Row>
              )}

              {/* ****** Price ****** */}
              <Row className="d-flex justify-content-center">
                <div className="plan-detail-container">
                  <Col
                    style={{ width: "100%" }}
                    // className="plan-name-value-container text-center"
                    className="plan-name-value-container d-flex justify-content-center align-items-center"
                  >
                    <p
                      style={{ width: "30%" }}
                      className="plan-detail-label-key-txt"
                    >
                      Price
                    </p>
                    <p
                      style={{ width: "70%" }}
                      className="plan-detail-label-value-txt"
                    >
                      : ₹{" "}
                      {selectedData?.plan_Amount
                        ? selectedData?.plan_Amount
                        : " 699 "}{" "}
                      (incl of GST)
                    </p>
                  </Col>
                </div>
              </Row>

              {/* ****** Coverage ****** */}
              <Row className="d-flex justify-content-center">
                <div className="plan-detail-container">
                  <Col
                    style={{ width: "100%" }}
                    // className="plan-name-value-container text-center"
                    className="plan-name-value-container d-flex justify-content-center align-items-center"
                  >
                    <p
                      style={{ width: "30%" }}
                      className="plan-detail-label-key-txt"
                    >
                      Coverage
                    </p>
                    <p
                      style={{ width: "70%" }}
                      className="plan-detail-label-value-txt"
                    >
                      : ₹ {getCoverageAmount(selectedData?.plan_Description)}
                    </p>
                  </Col>
                </div>
              </Row>

              {/* ****** Start ****** Date */}
              <Row className="d-flex justify-content-center">
                <div className="plan-detail-container">
                  <Col
                    style={{ width: "100%" }}
                    // className="plan-name-value-container text-center"
                    className="plan-name-value-container d-flex justify-content-center align-items-center"
                  >
                    <p
                      style={{ width: "30%" }}
                      className="plan-detail-label-key-txt"
                    >
                      Start Date
                    </p>
                    <p
                      style={{ width: "70%" }}
                      className="plan-detail-label-value-txt"
                    >
                      : {currentDate ? currentDate : "-"}
                    </p>
                  </Col>
                </div>
              </Row>

              {/* ****** End ****** Date */}
              <Row className="d-flex justify-content-center">
                <div className="plan-detail-container">
                  <Col
                    style={{ width: "100%" }}
                    // className="plan-name-value-container text-center"
                    className="plan-name-value-container d-flex justify-content-center align-items-center"
                  >
                    <p
                      style={{ width: "30%" }}
                      className="plan-detail-label-key-txt"
                    >
                      End Date
                    </p>
                    <p
                      style={{ width: "70%" }}
                      className="plan-detail-label-value-txt"
                    >
                      : {formattedEndDate ? formattedEndDate : "-"}
                    </p>
                  </Col>
                </div>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default GuideCard;
